/* Reposé — interacciones propias (vanilla). Guard de ejecución única. */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll (observer compartido) ---- */
  var revObserver = null;
  function initReveals() {
    if (reduced) {
      document.querySelectorAll('.mt-reveal').forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!revObserver) {
      revObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); revObserver.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    }
    document.querySelectorAll('.mt-reveal:not([data-mt-seen])').forEach(function (el) {
      el.setAttribute('data-mt-seen', '1');
      revObserver.observe(el);
    });
  }

  /* ---- Pilares sticky (arquetipo 27) ---- */
  function initPilares() {
    document.querySelectorAll('.mt-pil').forEach(function (root) {
      if (root.dataset.mtInit) return; root.dataset.mtInit = '1';
      var steps = root.querySelectorAll('.mt-pil-step');
      var imgs = root.querySelectorAll('.mt-pil-stage img');
      if (!steps.length || !imgs.length) return;
      function activate(i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      }
      activate(0);
      if (reduced) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var idx = parseInt(e.target.getAttribute('data-mt-idx'), 10) || 0;
            activate(idx);
          }
        });
      }, { threshold: 0.6, rootMargin: '-30% 0px -30% 0px' });
      steps.forEach(function (s) { obs.observe(s); });
    });
  }

  /* ---- Anillo de progreso rutina (arquetipo 54) ---- */
  function initRing() {
    document.querySelectorAll('.mt-ring').forEach(function (ring) {
      if (ring.dataset.mtInit) return; ring.dataset.mtInit = '1';
      if (reduced) { ring.classList.add('is-on'); return; }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { ring.classList.add('is-on'); obs.disconnect(); } });
      }, { threshold: 0.5 });
      obs.observe(ring);
    });
  }

  /* ---- Antes/Después deslizador (arquetipo 36) ---- */
  function initAntesDespues() {
    document.querySelectorAll('.mt-ad').forEach(function (ad) {
      if (ad.dataset.mtInit) return; ad.dataset.mtInit = '1';
      var before = ad.querySelector('.mt-ad-before');
      var handle = ad.querySelector('.mt-ad-handle');
      var range = ad.querySelector('.mt-ad-range');
      if (!before || !handle || !range) return;
      function set(v) {
        v = Math.max(0, Math.min(100, v));
        before.style.clipPath = 'inset(0 ' + (100 - v) + '% 0 0)';
        handle.style.left = v + '%';
      }
      range.addEventListener('input', function () { set(parseFloat(range.value)); });
      set(parseFloat(range.value) || 50);
    });
  }

  /* ---- FAQ acordeón (arquetipo 80) ---- */
  function initFaq() {
    document.querySelectorAll('.mt-faq-item').forEach(function (item) {
      if (item.dataset.mtInit) return; item.dataset.mtInit = '1';
      var q = item.querySelector('.mt-faq-q');
      if (!q) return;
      q.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
      q.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---- CTA magnético (arquetipo 88, aplicado a botones .mt-btn--magnet) ---- */
  function initMagnet() {
    if (reduced || !window.matchMedia('(hover:hover)').matches) return;
    document.querySelectorAll('.mt-btn--magnet').forEach(function (btn) {
      if (btn.dataset.mtInit) return; btn.dataset.mtInit = '1';
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = (e.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (e.clientY - (r.top + r.height / 2)) / r.height;
        btn.style.transform = 'translate(' + (dx * 8) + 'px,' + (dy * 8) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---- Galería página de producto ---- */
  function initPdpGallery() {
    document.querySelectorAll('.mt-pdp-gallery').forEach(function (g) {
      if (g.dataset.mtInit) return; g.dataset.mtInit = '1';
      var main = g.querySelector('.mt-pdp-main img');
      var thumbs = g.querySelectorAll('.mt-pdp-thumb');
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-full');
          if (src) main.src = src;
          thumbs.forEach(function (x) { x.classList.remove('is-on'); });
          t.classList.add('is-on');
        });
      });
    });
  }

  /* ---- Página de producto: variantes + precio dinámico ---- */
  function money(cents) {
    try {
      var s = (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return s + ' €';
    } catch (e) { return (cents / 100) + ' €'; }
  }
  function initPdpBuy() {
    document.querySelectorAll('.mt-pdp-info').forEach(function (root) {
      if (root.dataset.mtInit) return; root.dataset.mtInit = '1';
      var dataEl = root.querySelector('[data-mt-variant-data]');
      var idInput = root.querySelector('[data-mt-varid]');
      if (!dataEl || !idInput) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var priceEl = root.querySelector('[data-mt-price]');
      var compareEl = root.querySelector('[data-mt-compare]');
      var addBtn = root.querySelector('[data-mt-add]');
      var addText = root.querySelector('[data-mt-addtext]');
      var buttons = root.querySelectorAll('.mt-pdp-variant');
      var selected = {};
      root.querySelectorAll('.mt-pdp-variant.is-on').forEach(function (b) {
        selected[b.getAttribute('data-mt-opt')] = b.getAttribute('data-mt-val');
      });

      function findVariant() {
        return variants.find(function (v) {
          return (v.options || []).every(function (opt, i) {
            return selected[String(i + 1)] === opt;
          });
        });
      }
      function apply() {
        var v = findVariant();
        if (!v) return;
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.style.display = '';
            compareEl.textContent = money(v.compare_at_price);
          } else { compareEl.style.display = 'none'; }
        }
        if (addBtn && addText) {
          if (v.available) { addBtn.removeAttribute('disabled'); addText.textContent = addBtn.getAttribute('data-mt-label') || addText.textContent; }
          else { addBtn.setAttribute('disabled', 'disabled'); addText.textContent = 'Agotado'; }
        }
      }
      if (addText) addBtn.setAttribute('data-mt-label', addText.textContent);
      buttons.forEach(function (b) {
        b.addEventListener('click', function () {
          var pos = b.getAttribute('data-mt-opt');
          selected[pos] = b.getAttribute('data-mt-val');
          root.querySelectorAll('.mt-pdp-variant[data-mt-opt="' + pos + '"]').forEach(function (x) { x.classList.remove('is-on'); });
          b.classList.add('is-on');
          apply();
        });
      });
    });
  }

  function initAll() {
    initReveals();
    initPilares();
    initRing();
    initAntesDespues();
    initFaq();
    initMagnet();
    initPdpGallery();
    initPdpBuy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // El editor de Shopify re-renderiza secciones sin recargar
  document.addEventListener('shopify:section:load', initAll);
})();
